import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'navmobile',
  templateUrl: './navmobile.component.html',
  styleUrls: ['./navmobile.component.scss']
})
export class NavmobileComponent implements OnChanges {

  open: boolean = false;

  @Input()
  english: boolean;

  // *** Content *** //

  home: string;
  solutions: string;
  about: string;
  contact: string;

  // ***************************** //

  constructor() { }

  ngOnChanges (changes: SimpleChanges) {
    this.initContent(changes.english.currentValue)
  }

  initContent(b: boolean) {
    if (b) {
      this.home = 'Home';
      this.solutions = 'Solutions';
      this.about = 'About';
      this.contact = 'Contact';
    } else {
      this.home = 'Accueil';
      this.solutions = 'Solutions';
      this.about = 'A Propos';
      this.contact = 'Contact';
    }
  }

  toggleOverlay() {
    this.open = !this.open;
    if (window.scrollY < window.innerHeight) {
      window.scrollTo({
        left: 0,
        top: window.innerHeight,
        behavior: 'smooth',
      });
    }
    setTimeout(() => document.body.classList.toggle('noscroll', this.open), 600)
  }

}
